<template>
  <i-link class="i-layout-header-logo" :class="{ 'i-layout-header-logo-stick': !isMobile }" to="/">
    <img :src="rootPath + 'images/logo-small.png'" v-if="isMobile" />
    <img :src="rootPath + 'images/logo.png'" v-else-if="headerTheme === 'light'" />
    <img :src="rootPath + 'images/logo-dark.png'" v-else />
  </i-link>
</template>
<script>
  import { mapState } from 'vuex';
  import mixinPage from '../../../mixins/page';

  export default {
    name: 'iHeaderLogo',
    mixins: [mixinPage],
    computed: {
      ...mapState('admin/layout', ['isMobile', 'headerTheme'])
    }
  };
</script>
